module.exports = __webpack_public_path__ + "static/assets/b5abf2bf1c0b8114f89410545833f285.svg";